import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getDictionary, clearDictionary } from "src/redux";
import AddNewDictionaryElementModal from "src/app/modals/AddNewDictionaryElementModal/AddNewDictionaryElementModal";
import { RootState } from "src/redux/reducers";
import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";

interface GlobalTaskAddNewDictionaryElementModalProps {
  onClose: () => void;
  dictionaryUuid: string;
  getLists: () => Promise<void>;
  globalTaskUuid: string;
}

export default function GlobalTaskAddNewDictionaryElementModal({
  onClose,
  dictionaryUuid,
  getLists,
  globalTaskUuid,
}: GlobalTaskAddNewDictionaryElementModalProps) {
  const dispatch = useDispatch();

  const {
    dictionaryReducer: { dictionary, isDictionaryLoading },
  } = useSelector((state: RootState) => state);

  const updatedRequiredGlobalCreatorField = dictionary
    ? dictionary?.metaFields.map((field) => {
        if (field.type === MetaFieldType.GlobalCreator) {
          return { ...field, value: [globalTaskUuid], required: true };
        }
        return field;
      })
    : [];

  useEffect(() => {
    dispatch(getDictionary(dictionaryUuid));
  }, [dictionaryUuid, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearDictionary());
    };
  }, [dispatch]);

  return (
    <AddNewDictionaryElementModal
      onClose={onClose}
      dictionaryUuid={dictionaryUuid}
      getLists={getLists}
      isLoading={isDictionaryLoading}
      fields={updatedRequiredGlobalCreatorField}
    />
  );
}
